module.exports = __webpack_public_path__ + "static/media/secure.688a4cca.png";